import { Click, ClickType, ElementType, Impression } from '@fiverr-private/bianka_js';
import { getContext } from '@fiverr-private/fiverr_context';
import { bianka } from '@fiverr-private/obs';

const PAGE_NAME = 'listings_page';
const ELEMENT_NAME = 'query_suggestion';

interface QuerySuggestionParams {
    label: string;
    /** 1-based position of the suggestion in the row. */
    position: number;
}

/** Auto generated fields of the `@fiverr-private/impressionable` `onImpression` payload. */
export interface QuerySuggestionImpressionData {
    imp_id: string;
    parent_component_imp_id?: string | null;
    level: number;
    is_leaf: boolean;
    size_in_parent: number;
    visible_through_scroll: boolean;
}

interface QuerySuggestionImpressionParams extends QuerySuggestionParams {
    impressionData: QuerySuggestionImpressionData;
}

export const reportQuerySuggestionClick = ({ label, position }: QuerySuggestionParams) => {
    const { pageCtxId, userId } = getContext();

    bianka.reportActivity<Click>({
        type: Click,
        event: {
            type: 'clicked_on_listings_query_suggestion',
            clickType: ClickType.LEFT,
            element: {
                name: ELEMENT_NAME,
                type: ElementType.BUTTON,
                text: { value: label },
                position: { value: position },
            },
            user: {
                id: userId as number,
            },
            page: {
                ctxId: pageCtxId,
                name: PAGE_NAME,
            },
        },
    });
};

export const reportQuerySuggestionImpression = ({
    label,
    position,
    impressionData,
}: QuerySuggestionImpressionParams) => {
    const { pageCtxId, userId } = getContext();

    bianka.reportActivity<Impression>({
        type: Impression,
        event: {
            type: 'viewed_query_suggestion_in_listings',
            component: {
                impId: impressionData.imp_id,
                ...(impressionData.parent_component_imp_id && {
                    parentComponentImpId: impressionData.parent_component_imp_id,
                }),
                name: ELEMENT_NAME,
                text: label,
                level: impressionData.level,
                isLeaf: impressionData.is_leaf,
                positionInParent: position,
                sizeInParent: impressionData.size_in_parent,
                visibleThroughScroll: impressionData.visible_through_scroll,
            },
            user: {
                id: userId as number,
            },
            page: {
                ctxId: pageCtxId,
                name: PAGE_NAME,
            },
        },
    });
};
